import React from 'react'

import Button, { ButtonProps } from './Button'

/**
 * 無効ボタン
 */
const DisabledButton: React.FC<ButtonProps> = (props) => (
  <Button
    {...props}
    color="var(--color-disabled-text)"
    background="var(--color-disabled)"
  />
)

export default DisabledButton
